function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 48.5,
  y: 29,
  width: 3,
  height: 58.9
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 56.2,
  y: 22,
  width: 3,
  height: 58.5
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 64,
  y: 19.7,
  width: 3,
  height: 52.9
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 79.5,
  y: 24.9,
  width: 3,
  height: 32.2
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 71.7,
  y: 20.3,
  width: 3,
  height: 44.4
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M67.5,21.2c10.9,0,19.8,8.9,19.8,19.8c0,5.6-2.4,10.9-6.5,14.7l0,0l0,0L50,86L19.3,55.8l0,0l0,0 c-4.1-3.8-6.5-9.1-6.5-14.7c0-10.9,8.9-19.8,19.8-19.8c5.9,0,11.4,2.6,15.2,7.1L50,31l2.3-2.7C56.1,23.8,61.6,21.2,67.5,21.2  M67.5,18.2c-7,0-13.3,3.2-17.5,8.1c-4.2-5-10.5-8.1-17.5-8.1C19.9,18.2,9.7,28.4,9.7,41c0,6.7,2.9,12.7,7.5,16.9h0L50,90.2 l32.8-32.3h0c4.6-4.2,7.5-10.2,7.5-16.9C90.3,28.4,80.1,18.2,67.5,18.2L67.5,18.2z"
})))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M7,89.2c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S4.8,89.2,7,89.2 M7,86.2c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7 S10.9,86.2,7,86.2L7,86.2z"
})))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 82.4,
  y: 7.3,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 35.9628 -54.5994)",
  width: 3,
  height: 17.6
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M93.4,2.9c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S91.2,2.9,93.4,2.9 M93.4-0.1c-3.9,0-7,3.1-7,7s3.1,7,7,7 c3.9,0,7-3.1,7-7S97.3-0.1,93.4-0.1L93.4-0.1z"
}))));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 18.8,
  y: 64.9,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 62.2882 8.9558)",
  width: 3,
  height: 29.5
})));

var SvgHeart = function SvgHeart(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), React.createElement("g", null, _ref, _ref2, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 90.1,
    y1: 9.9,
    x2: 77.7,
    y2: 22.3
  }))), _ref3)), _ref4, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("line", {
    style: {
      fill: "#EDEDED"
    },
    x1: 30.8,
    y1: 69.2,
    x2: 9.9,
    y2: 90.1
  }))), _ref5))));
};

export default __webpack_public_path__ + "static/media/heart.ec1de862.svg";
export { SvgHeart as ReactComponent };